import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem, Reveal } from "@/components/shared/Reveal";
import { MapPin, Clock, Truck, Hash, Gauge, Fuel, Package, ShieldCheck, Camera, PenTool, User, CheckCircle2 } from "lucide-react";

const CUSTODY_ITEMS = [
  { icon: MapPin, label: "GPS Location" },
  { icon: Clock, label: "Timestamp" },
  { icon: Truck, label: "Truck ID" },
  { icon: Hash, label: "VIN / Unit Number" },
  { icon: Package, label: "Trailer" },
  { icon: Gauge, label: "Odometer" },
  { icon: Fuel, label: "Fuel Level" },
  { icon: Package, label: "Cargo Information" },
  { icon: ShieldCheck, label: "Seal Information" },
  { icon: Camera, label: "Existing Damage" },
  { icon: Camera, label: "Required Photographs" },
  { icon: User, label: "Outgoing / Incoming Driver" },
  { icon: PenTool, label: "Signatures" },
  { icon: CheckCircle2, label: "Custody Acceptance" },
];

export const RelayHandoff = () => {
  return (
    <section data-testid="relay-handoff-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading
          eyebrow="Relay Handoff"
          title="More Than Handing Over the Keys."
          description="A RelayRigs handoff captures the full digital chain of custody, creating a documented record of the transfer."
          testId="relay-handoff"
        />

        <RevealStagger className="mt-14 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {CUSTODY_ITEMS.map((item) => (
            <RevealItem key={item.label}>
              <div data-testid={`handoff-item-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-center gap-3 border border-rr-line rounded-xl px-5 py-4 hover:border-rr-orange/40 hover:bg-rr-surface transition-colors">
                <item.icon size={18} className="text-rr-orange shrink-0" />
                <span className="text-sm font-semibold text-rr-navy">{item.label}</span>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>

        <Reveal delay={0.3}>
          <div className="mt-10 flex items-center gap-3">
            <div className="flex-1 h-px bg-rr-line" />
            <span className="text-xs font-bold text-rr-muted uppercase tracking-widest">Outgoing Driver → Incoming Driver</span>
            <div className="flex-1 h-px bg-rr-line" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
